// 引入公共模块
import { 
  mergeParams,
  addParamsToLinksHandler,
  pageJumpHandler,
  pageJumpBlankHandler,
  initScrollHandler,
  initNavBarHandler,
} from './common.js';

// 命名空间模式
const App = {
  init() {
    addParamsToLinksHandler(mergeParams()); //为链接添加参数
    pageJumpHandler(); //页面跳转
    pageJumpBlankHandler(); // 页面跳转(新窗口打开)
    initScrollHandler(); // 滚动处理
    initNavBarHandler(); // 导航下拉处理
  },
  
};

// 文档加载后初始化
$(function () {
  App.init();
});
